import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SliderStandard from './Slider';

const ManualInputSlider = ({
  hideArrowsIfAllSlidesVisible = false,
  imageArray,
  imageHeight,
  imageWidth,
  navType,
  slideIndex,
  updateImageArraySize,
  visibleSlides,
  variant,
}) => {
  const finalVisibleSlides = visibleSlides
    ? visibleSlides.content
      ? visibleSlides.content
      : visibleSlides
    : 0;

  return (
    <div
      className={classNames({
        '[&_.slider-slide]:!min-h-[400px] [&_.slider-slide]:!h-full [&_.slider-slide]:max-[569px]:!min-h-[275px] [&_.slider-list]:max-[568px]:!overflow-y-scroll':
          variant === 'reviews-list',
      })}
    >
      <SliderStandard
        finalVisibleSlides={finalVisibleSlides}
        hideArrowsIfAllSlidesVisible={hideArrowsIfAllSlidesVisible}
        imageArray={imageArray}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        navType={navType}
        slideIndex={slideIndex}
        updateImageArraySize={updateImageArraySize}
      />
    </div>
  );
};

ManualInputSlider.propTypes = {
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  imageArray: PropTypes.array,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  updateImageArraySize: PropTypes.func,
  variant: PropTypes.oneOf(['reviews-list']),
  visibleSlides: PropTypes.object,
};

export default ManualInputSlider;
